import React from 'react';
import { Typography } from '@mui/material';
import FContactGrid from '../features/FContactGrid';

const PContacts = () => {
	return (
		<>
			<Typography component="h1" variant="h1">
				Contacts
			</Typography>
			<FContactGrid />
		</>
	);
};

export default PContacts;
